<template>
  <div class="login-page">
    <div class="login-box">
      <h2>商家登录</h2>

      <el-form ref="ruleFormRef" style="max-width: 600px" :model="ruleForm" :rules="rules" label-width="auto"
        class="demo-ruleForm" :size="formSize" status-icon>
        <el-form-item label="用户名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm(ruleFormRef)">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { post } from '@/api/http';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'LoginPage',
  setup() {
    const store = useStore();

    const router = useRouter();
    // 表单相关的响应式数据
    const formSize = ref('default')
    const ruleFormRef = ref(null)
    const ruleForm = reactive({
      name: '',
      password: ''
    })

    // 表单验证规则
    const rules = reactive({
      name: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        { min: 5, max: 15, message: '用户名长度应在 5 到 15 个字符之间', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 8, max: 16, message: '密码长度应在 8 到 16 个字符之间', trigger: 'blur' }
      ]
    })

    // 提交表单
    const submitForm = async (formEl) => {
      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          login()
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return
      formEl.resetFields()
    }

    // 登录请求
    const login = async () => {
      try {
        const response = await post('adminShop/login', {
          username: ruleForm.name,
          password: ruleForm.password
        })
        if (response.code === 200) {
          ElMessage.success('登录成功')

          store.commit('setToken', response.data.token);
          store.commit('setShop', response.data.shop);

          switch (response.data.shop.type) {

            case 23:
              router.replace({ name: 'Photos' })
              break;
            case 7:
              router.replace({ name: 'Dress' })
              break;
            case 8:
              router.replace({ name: 'MakeUp' })
              break;
            case 9:
              router.replace({ name: 'Emcee' })
              break;
            case 10:
              router.replace({ name: 'Plan' })
              break;
            case 11:
              router.replace({ name: 'Car' })
              break;
            case 12:
              router.replace({ name: 'Restaurant' })
              break;
          }


        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('登录失败', error)
        ElMessage.error('登录失败，请重试')
      }
    }

    return {
      ruleForm,
      rules,
      formSize,
      ruleFormRef,
      submitForm,
      resetForm
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: linear-gradient(45deg, #f2293a, #f96e52);
  padding: 0;
}

.login-box {
  background-color: white;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  width: 100%;
  max-width: 300px;
  text-align: center;
}

h2 {
  margin-bottom: 20px;
  color: #333;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-button {
  width: 100%;
  padding: 10px;
  font-size: 16px;
}
</style>
